var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoyHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29375",
    "data-name": "Group 29375",
    transform: "translate(-154 -182.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(154 182.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_1_",
    "data-name": "svgexport-17 (1)",
    transform: "translate(173 188.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49895",
    "data-name": "Path 49895",
    d: "M84.55,148.231h3.108v3.48H84.55Z",
    transform: "translate(-78.553 -132.561)",
    fill: "#fdcc9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49896",
    "data-name": "Path 49896",
    d: "M84.551,148.64a5.214,5.214,0,0,0,3.108.64v-1.05H84.551Z",
    transform: "translate(-78.554 -132.56)",
    fill: "#fcbc85"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_412",
    "data-name": "Ellipse 412",
    cx: 1.516,
    cy: 1.73,
    rx: 1.516,
    ry: 1.73,
    transform: "translate(0 8.544)",
    fill: "#fcbc85"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_413",
    "data-name": "Ellipse 413",
    cx: 1.516,
    cy: 1.73,
    rx: 1.516,
    ry: 1.73,
    transform: "translate(12.069 8.544)",
    fill: "#fcbc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49897",
    "data-name": "Path 49897",
    d: "M54.227,28.6c0-2.548-1.865-4.413-6.029-4.413S42.17,26.049,42.17,28.6s-.435,9.26,6.029,9.26S54.227,31.145,54.227,28.6Z",
    transform: "translate(-40.648 -21.627)",
    fill: "#fdcc9b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_414",
    "data-name": "Ellipse 414",
    cx: 0.653,
    cy: 0.715,
    rx: 0.653,
    ry: 0.715,
    transform: "translate(3.962 9.144)",
    fill: "#3b2519"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_415",
    "data-name": "Ellipse 415",
    cx: 0.195,
    cy: 0.195,
    rx: 0.195,
    ry: 0.195,
    transform: "translate(4.135 9.348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49898",
    "data-name": "Path 49898",
    d: "M61.058,69.279c.309.154.8-.524,1.938.066.207.108.33-.921-.886-.921C61.058,68.424,60.872,69.185,61.058,69.279Z",
    transform: "translate(-57.488 -61.191)",
    fill: "#51362a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_416",
    "data-name": "Ellipse 416",
    cx: 0.653,
    cy: 0.715,
    rx: 0.653,
    ry: 0.715,
    transform: "translate(9.915 9.144)",
    fill: "#3b2519"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_417",
    "data-name": "Ellipse 417",
    cx: 0.195,
    cy: 0.195,
    rx: 0.195,
    ry: 0.195,
    transform: "translate(10.088 9.348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49899",
    "data-name": "Path 49899",
    d: "M119.38,69.279c-.309.154-.8-.524-1.938.066-.207.108-.33-.921.886-.921C119.38,68.424,119.566,69.185,119.38,69.279Z",
    transform: "translate(-107.849 -61.191)",
    fill: "#51362a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49900",
    "data-name": "Path 49900",
    d: "M90.507,114.4c-.645,0-1.033-.482-1.033-.249s.186.676,1.033.676,1.033-.443,1.033-.676S91.152,114.4,90.507,114.4Zm0,2.143c-.223,0-.357-.167-.357-.086s.064.234.357.234.357-.153.357-.234S90.73,116.544,90.507,116.544Z",
    transform: "translate(-82.956 -102.028)",
    fill: "#fcbc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49901",
    "data-name": "Path 49901",
    d: "M85.393,128.923a8.43,8.43,0,0,1-1.638-.311c0,.105.3.521,1.638.521s1.638-.415,1.638-.521A8.432,8.432,0,0,1,85.393,128.923Z",
    transform: "translate(-77.842 -115.001)",
    fill: "#f7945e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49902",
    "data-name": "Path 49902",
    d: "M35.372,161.458v3.915H27.821C27.821,163.789,31.8,161.458,35.372,161.458Zm0,0v3.915h7.551C42.923,163.789,38.946,161.458,35.372,161.458Z",
    transform: "translate(-27.821 -144.389)",
    fill: "#f7941e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49903",
    "data-name": "Path 49903",
    d: "M79.852,161.458a9.89,9.89,0,0,0-2.293.288,3.071,3.071,0,0,0,2.293,1.08,3.409,3.409,0,0,0,2.375-1.06A9.941,9.941,0,0,0,79.852,161.458Z",
    transform: "translate(-72.301 -144.389)",
    fill: "#f36c21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49904",
    "data-name": "Path 49904",
    d: "M84.55,160.534a2.423,2.423,0,0,0,3.108,0A4.913,4.913,0,0,0,84.55,160.534Z",
    transform: "translate(-78.553 -143.33)",
    fill: "#fdcc9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49905",
    "data-name": "Path 49905",
    d: "M46.567,2.014S44.33-.83,39.68.242s-5,3.869-4.859,6.59.513,4.317.954,4.12.212-1.993.258-2.408.466-2.289,3.294-2.009a11.7,11.7,0,0,0,5.211-.746,5.86,5.86,0,0,0,1.591,1.445c1.262.464.848,3.559,1.342,3.559S50.39,3.645,46.567,2.014Z",
    transform: "translate(-34.06 -0.001)",
    fill: "#51362a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoyHighlighted);
export default __webpack_public_path__ + "static/media/BoyHighlighted.81df5ebe9eb440069d3c15b26ddb0004.svg";
export { ForwardRef as ReactComponent };